import React from "react";
import { NewTab, PageTab } from "../../../../../../components";
import InvoiceDetails from "./Invoices/InvoiceDetails";
import BillingAndNotifications from "./Invoices/BillingAndNotifications";
import QuickbooksIntegration from "./Invoices/QuickbooksIntegration";
import Discounts from "./Invoices/Discounts";

const Invoices = ({ setActiveTab, currentPlacement, editData }) => {
  const handleBack = () => {
    setActiveTab((prev) => prev + 1);
  };
  const InvoicesMenus = [
    {
      title: "Invoice Details",
      page: (
        <InvoiceDetails
          currentPlacement={currentPlacement}
          editData={editData}
        />
      ),
      type: "main",
    },
    {
      title: "Billing and Notifications",
      page: (
        <BillingAndNotifications
          currentPlacement={currentPlacement}
          editData={editData}
        />
      ),
      type: "main",
    },
    {
      title: "Quickbooks Integration",
      page: (
        <QuickbooksIntegration
          currentPlacement={currentPlacement}
          editData={editData}
        />
      ),
      type: "main",
    },
    {
      title: "Discounts",
      page: (
        <Discounts
          currentPlacement={currentPlacement}
          handleBack={handleBack}
          editData={editData}
        />
      ),
      type: "main",
    },
  ];
  return (
    // <div className="border-[1px] border-neutrals-50 rounded-b min-h-[69vh] overflow-auto">
    <div className="border-[1px] border-neutrals-50 rounded-b overflow-auto">
      {/* Invoices */}
      <NewTab
        tabs={InvoicesMenus}
        color="black"
        variant="text"
        activeVariant="text"
        mode="url"
        tabId="invoices"
      />
    </div>
  );
};

export default Invoices;
